import { render } from "./NcCheckbox.vue?vue&type=template&id=1f91de4c&scoped=true"
import script from "./NcCheckbox.vue?vue&type=script&lang=js"
export * from "./NcCheckbox.vue?vue&type=script&lang=js"

import "./NcCheckbox.vue?vue&type=style&index=0&id=1f91de4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f91de4c"]])

export default __exports__